import React, { useEffect, useRef, useState } from 'react';
import html2pdf from 'html2pdf.js';
import useMuiCompontent from '../../Hooks/useMuiCompontent';
import { BILL_DETAILS } from '../Repository/AppointmentsRepo';
import { toast } from 'react-toastify';
import Loading from '../../Component/Loading';
import moment from 'moment-timezone';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate, useParams } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import useReduxData from '../../Hooks/useReduxData';

const ViewPatientBill = ({ type }) => {
    const componentRef = useRef();
    const { CustomButton } = useMuiCompontent()
    const [patientBilling, setPatientBilling] = useState({})
    const [loader, setLoader] = useState(false)
    const { reduxData: userData } = useReduxData("userDataRDX")
    const { reduxData: MemberType, } = useReduxData("SubMemberTypeRDX")
    const { id, subpatientId, billId } = useParams()
    const navigate = useNavigate()
    const [shouldBreakPage, setShouldBreakPage] = useState(false);
    const pageLength = useRef();
    const handlePrint = () => {
        const element = componentRef.current;
        html2pdf()
            .set({
                margin: 3,
                filename: `patientBill.pdf`,
                image: { type: 'jpeg', quality: 1 },
                html2canvas: { scale: 2, useCORS: true, logging: true, windowWidth: 794, windowHeight: 1123 },
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                pagebreak: { mode: [], avoid: ['table', '.note', '.footer-row'] }
            })
            .from(element)
            .save();
    };


    const printPage = useReactToPrint({
        content: () => componentRef.current,
    });

    const getPatientBilling = async () => {
        let payload = {
            billId: billId,
            patientId: type === "Patients" ? id : MemberType ? subpatientId : subpatientId,
            roleTitle: userData.roleTitle,
        }
        setLoader(true)
        try {
            let response = await BILL_DETAILS(payload)
            setPatientBilling(response?.data)
            setLoader(false)
        } catch (error) {
            toast.error(error.message);
            setPatientBilling({})
            setLoader(false)
        }
    }

    const fullClinicAddress = [
        patientBilling?.clinicAddress,
        patientBilling?.clinicCity,
        patientBilling?.cinicState,
        patientBilling?.clinicZipCode,
    ].filter(Boolean).join(", ");

    const notesItems = [
        "This bill is generated electronically and does not require a signature.",
        "Services are inclusive of consumables unless mentioned.",
        "Please retain this bill for insurance or tax purposes.",
        "No personal health information is shared without consent in compliance with HIPAA."
    ]

    useEffect(() => {
        if (pageLength.current) {
            const height = pageLength.current.offsetHeight;
            console.log(height, "height")
            if (height > 700) setShouldBreakPage(true);
        }

    }, [patientBilling]);

    useEffect(() => {
        getPatientBilling()
    }, [])
    return (
        <>
            {loader && <Loading />}
            <div className="common-component-box">
                <header className="body_header">
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
                        <div className="d-flex align-items-center mb-2 mb-md-0">
                            <FaArrowLeft
                                className="me-2 cursor"
                                onClick={() => navigate(-1)}
                                role="button"
                                aria-label="Go Back"
                                title="Go Back"
                                style={{ fontSize: "1.2rem" }}
                            />
                            <h2 className="page_name mb-0">Patient Bill</h2>
                        </div>
                        <div className='d-flex flex-wrap align-items-center gap-2'>

                            <div className="d-flex flex-wrap gap-2 mt-2 mt-md-0">

                                <CustomButton
                                    onClick={printPage}
                                    variant="contained" >print</CustomButton>

                                <CustomButton
                                    onClick={handlePrint}
                                    variant="contained" >Download PDF</CustomButton>
                            </div>
                        </div>
                    </div>
                </header>

                <div ref={componentRef} className="common-white-bg-box mx-0 shadow patient_bill">
                    <div ref={pageLength}>
                        <div className="p-4 d-flex flex-column h-100" >
                            <div className='position-relative clinic-info d-flex'>
                                <div className="col-3"></div>
                                <div className='text-center col-5'>
                                    <h3 className='mb-0'>{patientBilling?.clinicName}</h3>
                                    <p className='mb-0'>{fullClinicAddress} </p>
                                    <p className='mb-0' >{patientBilling?.clinicGstNumber ? `GSTIN : ${patientBilling.clinicGstNumber}` : ""} {` Phone : ${patientBilling.providerMobile}`}</p>
                                    <p className='mb-0'>{`Email : ${patientBilling.providerEmail}`}</p>
                                </div>

                                <div className="barcode col-3 text-end" >
                                    <div dangerouslySetInnerHTML={{ __html: patientBilling?.barcode }} />
                                </div>
                            </div>
                            <hr />
                            <div>
                                <h4 className='text-center'>Medical Bill</h4>

                                <div className="d-flex justify-content-between mt-4 info">
                                    <div>
                                        <h5>Bill Details</h5>
                                        <p>Bill No : {patientBilling?.invoiceNumber ?? "N/A"}</p>
                                        <p>Date : {moment(patientBilling?.createdOn).format("DD/MM/YYYY")}</p>
                                        <p>Due Date : {moment(patientBilling?.dueDate).format("DD/MM/YYYY")}</p>
                                    </div>
                                    <div>
                                        <h5>Patient Information</h5>
                                        <p>Appointment No : {patientBilling?.appointmentNumber ?? "N/A"} </p>
                                        <p>Name : {patientBilling?.patientFirstName ?? ""} {patientBilling?.patientLastName ?? ""} </p>
                                        <p>Patient ID : {patientBilling?.patientId} </p>
                                    </div>
                                </div>

                                <hr />

                            </div>
                            <div className='flex-fill pb-3'>

                                <table className="table mt-4 a4-print-table" style={{ textIndent: '10px' }}>
                                    <thead>
                                        <tr>
                                            <th scope="col" className="col-5 description-service" align="left">Description of service</th>
                                            <th scope="col" align="left">HSN Code</th>
                                            <th scope="col" align="left" >Qty</th>
                                            <th scope="col" align="left">Price ({patientBilling?.currencyImage ?? ""})</th>
                                            <th scope="col" align="left">GST (%)</th>
                                            <th scope="col" align="right" className='text-end'> <div style={{ paddingRight: '10px' }}>
                                                TOTAL ({patientBilling?.currencyImage ?? ""})
                                            </div></th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {
                                            patientBilling?.billingItems?.map((cur, index) => {
                                                return (<tr key={cur?.id || index}>
                                                    <td style={{ textIndent: '10px' }}>{cur?.serviceName ?? "-"}</td>
                                                    <td>{cur?.hsnCode ?? "-"}</td>
                                                    <td>{cur?.quantity ?? ""}</td>
                                                    <td>{cur?.currencyImage ?? ""}{cur?.taxableValue ?? "-"}</td>
                                                    <td>{cur?.gstRate ?? "Exempt"}</td>
                                                    <td align="right"><div style={{ paddingRight: '10px' }}>
                                                        {cur?.amount ?? "-"}
                                                    </div></td>
                                                </tr>
                                                );
                                            })
                                        }

                                    </tbody>
                                </table>

                                <div className="mt-4">
                                    <strong style={{ fontSize: "16px" }}>GST Details</strong>
                                </div>

                                <table className="table mt-2 a4-print-table">
                                    <thead>
                                        <tr>
                                            <th scope="col" align="left" style={{ textIndent: '10px' }}>HSN Code</th>
                                            <th scope="col" align="left" >Amount ({patientBilling?.currencyImage ?? ""})</th>
                                            <th scope="col" align="left">CGST(%)</th>
                                            <th scope="col" align="left">CGST Amt ({patientBilling?.currencyImage ?? ""})</th>
                                            <th scope="col" align="left">SGST(%)</th>
                                            <th scope="col" align="left">SGST Amt ({patientBilling?.currencyImage ?? ""})</th>
                                            <th scope="col" align="left">IGST(%)</th>
                                            <th scope="col" align="left">IGST Amt ({patientBilling?.currencyImage ?? ""})</th>
                                            <th scope="col" align="right" className='text-end'><div style={{ paddingRight: '10px' }}>Total Amount ({patientBilling?.currencyImage ?? ""})</div></th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {
                                            patientBilling?.billingItems?.map((cur, index) => {
                                                return (<tr key={cur?.id || index}>
                                                    <td style={{ textIndent: '10px' }}>{cur?.hsnCode ?? "-"}</td>
                                                    <td>{cur?.taxableValue ?? "-"}</td>
                                                    <td>{cur?.cgstRate ?? "-"}</td>
                                                    <td>{cur?.cgstAmount ?? "-"}</td>
                                                    <td>{cur?.sgstRate ?? "-"}</td>
                                                    <td>{cur?.sgstAmount ?? "-"}</td>
                                                    <td>{cur?.igstRate ?? "-"}</td>
                                                    <td>{cur?.igstAmount ?? "-"}</td>
                                                    <td align="right"><div style={{ paddingRight: '10px' }}>{cur?.amount ?? "-"}</div></td>
                                                </tr>
                                                )
                                            })
                                        }

                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td style={{ textIndent: '10px' }}><strong>Sub Total</strong></td>
                                            <td></td>
                                            <td></td>
                                            <td>
                                                <strong>
                                                    {patientBilling?.billingItems
                                                        ?.reduce((sum, cur) => sum + (parseFloat(cur?.cgstAmount) || 0), 0)
                                                        .toFixed(2) || "-"}
                                                </strong>
                                            </td>
                                            <td></td>
                                            <td>
                                                <strong>
                                                    {patientBilling?.billingItems
                                                        ?.reduce((sum, cur) => sum + (parseFloat(cur?.sgstAmount) || 0), 0)
                                                        .toFixed(2) || "-"}
                                                </strong>
                                            </td>
                                            <td></td>
                                            <td>
                                                <strong>
                                                    {patientBilling?.billingItems
                                                        ?.reduce((sum, cur) => sum + (parseFloat(cur?.igstAmount) || 0), 0)
                                                        .toFixed(2) || "-"}
                                                </strong>
                                            </td>
                                            <td align="right">
                                                <div style={{ paddingRight: '10px' }}>
                                                    <strong>
                                                        {patientBilling?.billingItems
                                                            ?.reduce((sum, cur) => sum + (parseFloat(cur?.amount) || 0), 0)
                                                            .toFixed(2) || "-"}
                                                    </strong>
                                                </div>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>

                            <div style={{ minHeight: "200px" }}>
                                <table className="table mt-4  a4-print-table payment-status-table" style={{ width: "100%", tableLayout: "fixed" }}>
                                    <thead>
                                        <tr>
                                            <td style={{ padding: "8px", width: "50%", border: "1px solid #38C4B9", wordWrap: "break-word", overflowWrap: "break-word", textIndent: "10px" }}>
                                                Payment Status
                                            </td>
                                            <td style={{ borderLeft: "1px solid #38C4B9", padding: "0 10px", width: "50%", border: "1px solid #38C4B9", wordWrap: "break-word", overflowWrap: "break-word", textIndent: "10px" }}>
                                                {(() => {
                                                    const paymentType = patientBilling?.paymentType || "Cash";

                                                    switch (paymentType) {
                                                        case "Cash":
                                                            return (
                                                                <>
                                                                    Paid By CASH{" "}
                                                                    <strong>
                                                                        {patientBilling?.billingItems
                                                                            ?.reduce((sum, cur) => sum + (parseFloat(cur?.amount) || 0), 0)
                                                                            .toFixed(2) || "-"}
                                                                    </strong>
                                                                    ({patientBilling?.currencyImage ?? ""})
                                                                </>
                                                            );

                                                        case "Card":
                                                            return (
                                                                <>
                                                                    Paid By Card ({patientBilling?.cardType}
                                                                    {patientBilling?.cardNumber
                                                                        ? ` ending ${patientBilling.cardNumber}`
                                                                        : ""}
                                                                    )
                                                                </>
                                                            );

                                                        case "Cheque":
                                                            return (
                                                                <>
                                                                    Paid By Cheque{" "}
                                                                    {patientBilling?.chequeNumber
                                                                        ? `(No. ${patientBilling.chequeNumber})`
                                                                        : ""}
                                                                </>
                                                            );

                                                        case "Online Payment":
                                                            return (
                                                                <>
                                                                    Online Payment{" "}
                                                                    {patientBilling?.transactionId
                                                                        ? `(Transaction ID ${patientBilling.transactionId})`
                                                                        : ""}
                                                                </>
                                                            );

                                                        case "Insurance":
                                                            return <>Paid by Insurance</>;

                                                        default:
                                                            return (
                                                                <>
                                                                    Paid By CASH{" "}
                                                                    <strong>
                                                                        {patientBilling?.billingItems
                                                                            ?.reduce((sum, cur) => sum + (parseFloat(cur?.amount) || 0), 0)
                                                                            .toFixed(2) || "-"}
                                                                    </strong>
                                                                    ({patientBilling?.currencyImage ?? ""})
                                                                </>
                                                            );
                                                    }
                                                })()}

                                            </td>
                                        </tr>
                                    </thead>
                                    <tfoot>
                                        <tr>
                                            <td style={{ verticalAlign: "top", padding: "10px 10px", width: "50%", border: "1px solid #38C4B9", textIndent: "10px" }}>
                                                Payment Date
                                            </td>
                                            <td style={{ borderLeft: "1px solid #38C4B9", padding: "0 10px", width: "50%", border: "1px solid #38C4B9", textIndent: "10px" }}>
                                                {moment(patientBilling?.createdOn).format("DD/MM/YYYY")}
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>

                                <div className="mt-4 note" style={{ pageBreakInside: "avoid" }}>
                                    <strong>Notes:</strong>
                                    <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                                        {notesItems.map((item, index) => (
                                            <li key={index}>&bull;  {item}</li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="mx-0 note" style={{ pageBreakInside: "avoid" }}>
                                    <strong>Terms:</strong> All services are subject to GST as per Indian tax regulations. HSN/SAC codes are provided for transparency.
                                </div>

                                <div className="mt-5 qr-code-section footer-row">
                                    <div className="row align-items-center">
                                        <div className="col-12 col-sm-4 col-md-4 mb-3 mb-sm-0 text-center text-sm-start">
                                            <div
                                                style={{ width: "10%", height: "10%" }}
                                                dangerouslySetInnerHTML={{ __html: patientBilling?.qrCode }}
                                            />
                                        </div>
                                        <div className="col-12 col-sm-8 col-md-8 text-center text-sm-start">
                                            <p className="mb-1 text-sm text-dark">
                                                Generated for {patientBilling?.clinicName} Billing by Winkdoc Billing System
                                            </p>
                                            <p className="mb-0 text-sm">
                                                Learn more about our billing system at:{" "}
                                                <a
                                                    href="https://winkdoc.com"
                                                    className="text-primary text-decoration-none"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    Winkdoc Home
                                                </a>
                                            </p>
                                            <p>
                                                For queries, contact{" "}
                                                <a
                                                    href="mailto:billing@apollohospitals.com"
                                                    className="text-primary text-decoration-none"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {`${patientBilling.providerEmail}`}
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>


                </div>
            </div>

            <style>
                {`
                    @media print {
                    @page {
                        size: A4;
                        margin: 0;
                    }

                    html, body {
                        margin: 0 !important;
                        padding: 0 !important;
                        width: 210mm;
                        height: 297mm;
                        overflow: hidden;
                        box-sizing: border-box;
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                    }

                    .common-white-bg-box,
                    .patient_bill {
                        margin: 0 !important;
                        padding: 0 !important;
                        width: 100% !important;
                        height: auto !important;
                        overflow: visible !important;
                        box-shadow: none !important;
                        background: white !important;
                        transform: scale(0.90);
                    }

                    .p-4 {
                        padding: 0 !important;
                        margin: 0 !important;
                    }

                    .a4-print-table,
                    .payment-status-table {
                        width: 100% !important;
                        table-layout: auto !important;
                        border-collapse: collapse !important;
                    }

                    .payment-status-table td {
                        word-wrap: break-word;
                        overflow-wrap: break-word;
                        white-space: normal !important;
                    }

                    .note,
                    .footer-row,
                    .qr-code-section {
                        page-break-inside: avoid !important;
                        break-inside: avoid !important;
                        display: block !important;
                    }

                    .h-100 {
                        height: auto !important;
                    }

                    .qr-code-section {
                        margin-top: 20px !important;
                    }
                    }
                `}
            </style>


        </>

    );
};

export default ViewPatientBill;
